<template>
  <hic-list-page v-if="permission.datacenter_data_query" title="日志列表" :entities="entities" :condition="condition" @load="page" keyword-placeholder="请输入医生姓名" :loading="meta.loading">
    <!-- <el-table-column align="center" label="时间" prop="logTime" width="100">
      <template #default="{ row }">
        <el-button type="primary" icon="el-icon-search" circle size="mini" plain @click="open(row)" />
      </template>
    </el-table-column> -->
    <el-table-column align="center" label="访问时间" prop="logTime" width="200">
      <template #default="{ row }">
        <div>{{ row.logTime | fmtDatetime }}</div>
      </template>
    </el-table-column>
    <el-table-column align="left" label="医生姓名" width="120" prop="name">
      <template #default="{ row }">
        <div>{{ row.doctorName }}</div>
      </template>
    </el-table-column>
    <el-table-column align="left" label="访问页面" prop="pageName">
      <template #default="{ row }">
        <el-link type="primary" target="_blank" :href="'#' + row.url">{{ row.pageName }}</el-link>
      </template>
    </el-table-column>
    <el-table-column align="left" label="访问参数" prop="paras"></el-table-column>
    <el-table-column align="left" label="包含模块" prop="moduleCodes">
      <template #default="{ row }">
        <div>{{ row.moduleCodes |  moduleCodesFilter}}</div>
      </template>
    </el-table-column>
  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    data() {
      return {
        meta: {
          loading: false,
        },
        condition: {
          keyword: null,
          sort: "id",
          asc: false,
          pageSize: 20,
          pageIndexOnViewer: 1
        },
        entities: {},
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    },
    filters: {
      moduleCodesFilter(val) {
        try {
          if (!val) return "";
          val = JSON.parse(val);
          let list = val.map((el) => {
            return el.name;
          });
          return list.join(",");
        } catch (error) {
          return val;
        }
      },
    },
    methods: {
      page() {
        this.meta.loading = true;
        try {
          api.Log.query(this.condition)
            .then((res) => {
              this.entities = res;
            })
            .catch((err) => {
              this.$message.error(err.message || err);
            })
            .finally(() => {
              this.meta.loading = false;
            });
        } catch (err) {
          if (err && err != "cancel") {
            console.log(err);
            this.$message.error(err.message || err);
          }
        }
      },
      open(row) {},
    },
  };
</script>
